export default "__VITE_ASSET__CKGsBGu$__"